import { useCallback, useEffect } from "react";
import {
  onMessage,
  subscribeCaseList,
  unsubscribeCaseList,
} from "../services/socketService";
import {
  applyCaseList,
  applyCaseUpdate,
  applyRemove,
  applyServiceUpdate,
  applyUpsert,
} from "../assets/helpers/caseListReducer";

const reducersByType = {
  caseListSubscribe: (list, data) => applyCaseList(list, data?.cases),
  notifCaseUpsert: applyUpsert,
  notifCaseUpdate: applyCaseUpdate,
  notifServiceUpdate: applyServiceUpdate,
  notifCaseRemove: applyRemove,
};

/**
 * Mantiene la lista plana de casos sincronizada con el socket mientras la vista está montada.
 * Devuelve `subscribe(filters)`, que debe llamarse cada vez que cambien los filtros de la vista;
 * retorna false si el socket no estaba abierto (la suscripción se enviará al conectar).
 * Al desmontar envía `caseListUnsubscribe`.
 */
export default function useCaseListSocket(setCaseList) {
  useEffect(() => {
    const unsubscribers = Object.entries(reducersByType).map(([type, reducer]) =>
      onMessage(type, (data) => setCaseList((prev) => reducer(prev, data)))
    );
    return () => {
      unsubscribers.forEach((unsubscribe) => unsubscribe());
      unsubscribeCaseList();
    };
  }, [setCaseList]);

  return useCallback((filters) => subscribeCaseList(filters), []);
}
